function StatCard({ label, value, icon, color }: { label: string; value: any; icon: React.ReactNode; color: string }) {
  const colorMap: Record<string, string> = {
    blue: 'text-blue-500 bg-blue-50 dark:bg-blue-900/20',
    green: 'text-green-500 bg-green-50 dark:bg-green-900/20',
    red: 'text-red-500 bg-red-50 dark:bg-red-900/20',
    yellow: 'text-yellow-500 bg-yellow-50 dark:bg-yellow-900/20',
    purple: 'text-purple-500 bg-purple-50 dark:bg-purple-900/20',
    cyan: 'text-cyan-500 bg-cyan-50 dark:bg-cyan-900/20',
    emerald: 'text-emerald-500 bg-emerald-50 dark:bg-emerald-900/20',
    orange: 'text-orange-500 bg-orange-50 dark:bg-orange-900/20',
    gray: 'text-gray-500 bg-gray-50 dark:bg-gray-900/20',
  };

  return (
    <div className="bg-[var(--color-bg-secondary)] rounded-lg border border-[var(--color-border)] p-3">
      <div className="flex items-center gap-2 mb-1">
        <div className={`p-1.5 rounded ${colorMap[color] || colorMap.gray}`}>{icon}</div>
        <span className="text-xs text-[var(--color-text-tertiary)]">{label}</span>
      </div>
      <div className="text-lg font-bold text-[var(--color-text)]">{value}</div>
    </div>
  );
}

export { StatCard };
